import React from 'react';
import './Shipping.css';

function Shipping() {
  return (
    <div className="shipping-page">
      <div className="container">
        <section className="shipping-hero">
          <h1>🚚 Nationwide Shipping</h1>
          <p className="subtitle">Delivered Across South Africa</p>
        </section>

        <section className="shipping-content">
          <p className="intro-text">
            We deliver to every corner of South Africa, from major cities to smaller towns. 
            Whether you're ordering a single accessory or a full traditional outfit, your 
            Heritage Hub purchase is packed with care and shipped reliably to your door.
          </p>

          <div className="shipping-what-to-expect">
            <h2>What you can expect:</h2>
            <ul className="shipping-list">
              <li>Nationwide delivery across all 9 provinces</li>
              <li>Reliable courier partners for safe handling</li>
              <li>Order tracking provided once your parcel is dispatched</li>
              <li>Secure packaging to protect delicate cultural pieces</li>
            </ul>
          </div>

          <section className="shipping-commitment">
            <p>
              We believe everyone deserves access to authentic South African heritage — 
              no matter where you live.
            </p>
          </section>
        </section>
      </div>
    </div>
  );
}

export default Shipping;
